import * as React from "react";
import { IWorkflowStatus } from "@nkr/models/index";
import { IApplicationState, AppActionCreators, IAppState } from "@nkr/store/index";
import { Dispatch, connect } from "react-redux";
import StatusList from "./status-list";

interface IProps {
    centerId?: number,
    isCenter: boolean
}

interface IStateProps {
    app: IAppState
}

interface IState {
    statusList: IWorkflowStatus[],
    dispositionList: any[]
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void
}

type TProps = IStateProps & IDispatchProps & IProps

class DashCenterWorkflowStatus extends React.Component<TProps, IState> {
    readonly state: IState = {
        statusList: [],
        dispositionList: []
    }

    render = () => {
        return (
            <>
                {this.props.isCenter == true && (
                    <StatusList
                        centerId={this.props.centerId}
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(DashCenterWorkflowStatus)